<interacta-community-selection-dialog
    [communityTypeFilter]="CommunityType.CUSTOM"
    [emptyLabel]="'I_LAB.CAN_NOT_CREATE_POST_MESSAGE'"
    [isOpen]="true"
    [recentCommunities]="recentCommunities()"
    [workspaces]="workspaces()"
    (closeDialog)="selectCommunity.emit(null)"
    (selectedCommunity)="selectCommunity.emit($event)"
/>
